import { DownloadLink, onDownloadLinkClick, Row } from 'components/core-v2'

export const DocumentsTab = () => (
  <>
    <Row>
      <DownloadLink
        onClick={() =>
          onDownloadLinkClick({
            url: '/api/absa/documentation/CustomisedNoteTerms.pdf'
          })
        }
      >
        Absa Structure Note Programme
      </DownloadLink>
    </Row>
    <Row>
      <DownloadLink
        onClick={() =>
          onDownloadLinkClick({
            url: '/api/absa/documentation/CustomisedNoteAPS.pdf'
          })
        }
      >
        Note Applicable Pricing Supplement
      </DownloadLink>
    </Row>
    <Row showBottomBorder>
      <DownloadLink
        onClick={() =>
          onDownloadLinkClick({
            url: '/api/absa/documentation/AbsaPlatformTCs.pdf'
          })
        }
      >
        Platform Terms & Conditions
      </DownloadLink>
    </Row>
  </>
)
